// extracted by mini-css-extract-plugin
export default {"timeline-controls__counter":"lsf-timeline-controls__counter","timeline-controls__main-controls":"lsf-timeline-controls__main-controls","timeline-controls":"lsf-timeline-controls","button":"lsf-button","timeline-controls__time":"lsf-timeline-controls__time","timeline-controls__time-section":"lsf-timeline-controls__time-section","timeline-time":"lsf-timeline-time","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385738
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  